import { SceneManager } from '../managers/SceneManager.js';
import { UIManager } from '../managers/UIManager.js';
import { StoryManager } from '../managers/StoryManager.js';
import { PodManager } from '../managers/PodManager.js';
import { ViewManager } from '../managers/ViewManager.js';
import { SpeechBubbleManager } from '../managers/SpeechBubbleManager.js';
import { ToolsetManager } from '../managers/ToolsetManager.js';
import { IntroManager } from '../managers/IntroManager.js';
import { NewsletterManager } from '../managers/NewsletterManager.js';
import { FooterManager } from '../managers/FooterManager.js';

class App {
    constructor() {
        // Create scene manager first (needed for intro)
        this.sceneManager = new SceneManager(this);
        this.sceneManager.init();

        // Create pod manager (needed for intro)
        this.podManager = new PodManager(this.sceneManager);
        
        // Create speech bubble manager (needed for intro)
        this.speechBubbleManager = new SpeechBubbleManager(this);
        
        // Create other managers but don't initialize yet
        this.viewManager = new ViewManager(this);
        this.storyManager = new StoryManager(this);
        this.uiManager = new UIManager(this);
        this.toolsetManager = new ToolsetManager(this);
        this.newsletterManager = new NewsletterManager(this);
        this.footerManager = new FooterManager(this);

        // Initialize intro manager last
        this.introManager = new IntroManager(this);
        
        // Add event listener for intro completion
        this.introManager.addEventListener('complete', () => {
            this.initializeAfterIntro();
        });
        
        // Start the intro
        this.introManager.init();

        // Start animation loop
        this.animate();

        // Handle window resizing
        window.addEventListener('resize', () => this.handleResize());

        console.log('App initialized');
    }

    animate = (time) => {
        requestAnimationFrame(this.animate);
        this.sceneManager.render();
        this.podManager.update(time);
        
        // Update speech bubble position if active
        if (this.speechBubbleManager) {
            this.speechBubbleManager.update();
        }
    }

    handleResize() {
        this.sceneManager.onWindowResize();
    }
    
    initializeAfterIntro() {
        // Initialize UI manager to show navigation options
        this.uiManager.init();
        
        // Show footer after intro
        this.footerManager.show();
        
        // Add social links
        this.footerManager.addSocialLink('X', 'https://twitter.com/osourcethinking');
        this.footerManager.addSocialLink('TikTok', 'https://tiktok.com/@opensourcethinking');
        
        console.log('Main site initialized after intro');
    }
}

// Start the application
window.addEventListener('DOMContentLoaded', () => {
    new App();
});
